import React, {Fragment} from 'react';
import {I18n} from '../i18n/I18n';

export const TreatmentMinDays = ({extraDays, minimalStay}) =>
  !!extraDays ? (
    <span className='minimal-days'>
      <I18n t='search.card.stay_from' /> {minimalStay} <I18n t='search.card.possible_days' />
    </span>
  ) : null;
